/** Extract a user-facing message from a Budy API client error. */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (typeof error !== "object" || error === null) {
    return fallback;
  }

  const response = (error as { response?: { data?: { detail?: unknown } } })
    .response;
  const detail = response?.data?.detail;

  if (typeof detail === "object" && detail !== null && "message" in detail) {
    const message = (detail as { message?: unknown }).message;
    if (typeof message === "string" && message.trim()) {
      return message;
    }
  }

  if (typeof detail === "string" && detail.trim()) {
    return detail;
  }

  const message = (error as { message?: unknown }).message;
  if (typeof message === "string" && message.trim()) {
    return message;
  }

  return fallback;
}
